import { axiosInstance } from '~/common/utils/api.util';

import type { ApiResponse } from '~/common/types/api.type';
import type { StoreStatistics } from '~/features/dashboard/types/dashboard.type';

/**
 * 매장별 통계 조회
 * @description 매장별 통계를 조회합니다
 * @endpoint GET /admin/dashboard/store-statistics
 * @returns 매장별 통계 목록
 */
export function getDashboardStoreStatisticsApi() {
  return axiosInstance.get<ApiResponse<StoreStatistics[]>>('/admin/dashboard/store-statistics');
}
